// extracted by mini-css-extract-plugin
module.exports = {"tableDiv":"choosefromtemplates_tableDiv__2LhKm","addBtn":"choosefromtemplates_addBtn__2FQJB","updateBtnLoader":"choosefromtemplates_updateBtnLoader__5A78-"};